import { jsx } from 'react/jsx-runtime';
import { NavigationMenuItem, NavigationMenuLink, NavigationMenuTrigger } from '@radix-ui/react-navigation-menu';
import styles from './Pagination.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

const overridedProps = {
    "aria-controls": undefined,
    "data-state": undefined,
    "aria-expanded": undefined,
    "data-disabled": undefined,
};
const PaginationItem = ({ totalPages, isCurrentPage, pageNumber, inverse, buildHref, onClick, }) => {
    const { items: itemsClasses, itemInteract: itemInteractClasses, selected: selectedClasses, ring: ringClasses, } = styles({
        inverse,
    });
    const selectedLabel = `Page ${pageNumber} of total ${totalPages} pages`;
    const pageLabel = `Go to${pageNumber === totalPages ? " last page," : ""} Page ${pageNumber}`;
    const dataItem = {
        label: pageNumber,
        "aria-label": isCurrentPage ? selectedLabel : pageLabel,
    };
    const classNames = cn(itemsClasses(), ringClasses(), isCurrentPage ? selectedClasses() : itemInteractClasses());
    const commonProps = {
        className: classNames,
        "aria-label": dataItem["aria-label"],
        onClick,
    };
    const ItemComponent = typeof buildHref === "function"
        ? NavigationMenuLink
        : NavigationMenuTrigger;
    if (typeof buildHref === "function" && !isCurrentPage) {
        commonProps.href = buildHref(pageNumber);
    }
    return (jsx(NavigationMenuItem, { value: `${pageNumber}`, children: jsx(ItemComponent, Object.assign({}, commonProps, { role: "link", "aria-current": isCurrentPage ? "page" : undefined }, overridedProps, { children: dataItem.label })) }, pageNumber));
};

export { PaginationItem };
